import { render, staticRenderFns } from "./PassengerFindDetailsV2.vue?vue&type=template&id=784a5cb1&scoped=true&"
import script from "./PassengerFindDetailsV2.vue?vue&type=script&lang=js&"
export * from "./PassengerFindDetailsV2.vue?vue&type=script&lang=js&"
import style0 from "./PassengerFindDetailsV2.vue?vue&type=style&index=0&id=784a5cb1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784a5cb1",
  null
  
)

export default component.exports